// extracted by mini-css-extract-plugin
export default {"root":"EditPropertyForm_root__PSVen","form":"EditPropertyForm_form__fw7rD","body":"EditPropertyForm_body__3S+5E","footer":"EditPropertyForm_footer__vQFC9"};